import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/manufacturingScheduleReportActions'
import * as api from '../../../api/reports/jobs/manufacturingScheduleReport'

function* manufacturingScheduleReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* manufacturingScheduleReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchmanufacturingScheduleReportGetJobList() {
  yield takeLatest(
    constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.ACTION,
    manufacturingScheduleReportGetJobList
  )
}

function* watchmanufacturingScheduleReportGetFullReport() {
  yield takeLatest(
    constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.ACTION,
    manufacturingScheduleReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchmanufacturingScheduleReportGetJobList),
    fork(watchmanufacturingScheduleReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/manufacturingScheduleReportSaga.js